/** Textos reutilizados ao avisar impacto de troca de canal nas automações. */
export const WHATSAPP_CHANNEL_AUTOMATIONS_IMPACT_COPY = {
  alert:
    "Automações personalizadas dependem do canal WhatsApp ativo. Ao trocar de canal,  será necessário configurá-las novamente.",
  dialogParagraph:
    "Ao mudar o canal WhatsApp, os modelos de mensagem disponíveis também mudam.",
  dialogHighlight:
    "Todas as automações personalizadas serão removidas e precisarão ser configuradas novamente.",
  dialogSystemDefaultsNote:
    "As automações padrão do sistema (confirmação, cancelamento e pagamento) continuam ativas.",
  automationsPanelSubtitle:
    "Automações personalizadas usam os modelos do canal WhatsApp ativo. Se você trocar de canal, será necessário configurá-las novamente.",
} as const;
